import * as React from 'react';
import { IListItem } from '../../common/classes/list-item';

export type IProviderListItemProps = IListItem;

export const EventListItem: React.StatelessComponent<IProviderListItemProps> = props => {
    return (
        <li className="adage-search-item">
            <div className="adage-search-item-content adage-date-listing-item ">
                <div className="adage-date-listing-item-details">
                    <h3 className="adage-search-item-content-heading"><a href={props.pageUrl}>{props.name}</a></h3>
                    <p>{props.time}</p>

                    <p>{props.locations ? props.locations[0] : null}</p>
                </div>
                <p className="adage-date-listing-item-date">{props.date} <span>{props.day}</span></p>
            </div>
            {props.ctaUrl ?
                <div className="adage-search-item-action">
                    <a className="btn btn-primary" href={props.ctaUrl}>{props.ctaText}</a>
                </div>
            : null}
        </li>
    )
}